<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useTeacherRecommended } from '../../model/additional-questions/teacher-recommended.hooks'
import { yesNoOptions } from '../../config/additional-questions'

defineOptions({
  name: 'TeacherRecommended',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setRecommended,
} = useTeacherRecommended()

</script>

<template>
  <FormRow
    :label="label"
    required
  >
    <RadioItem
      v-for="option in yesNoOptions"
      :key="option.value.toString()"
      :label="option.label"
      :mode="mode"
      :checked="tutorApplicationStore.recommended === option.value"
      @click="setRecommended(option.value)"
    />
  </FormRow>
</template>
